/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.MultiSearch";
        class MultiSearchWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    return new MultiSearchWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    MultiSearchWidgetInstanceClass.HtmlData = htmlData;
                    if (this.Instances != null && this.Instances.length > 0) {
                        this.Instances.forEach(function (instance) {
                            instance.presentInstance();
                        });
                    }
                };
                core.Loader.getVersionedHTML('widgets/MultiSearch/multisearch.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
            }
        }
        Widgets.MultiSearchWidgetTypeClass = MultiSearchWidgetTypeClass;
        class MultiSearchWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                // General config
                this._showQueries = true;
                this._showDocTypes = true;
                this._docTypeMultiSelect = true;
                this._publishAsQuery = true;
                this._publishAsHitList = false;
                // UI Elements
                this._instanceSelector = null;
                this._queryTypePanel = null;
                this._showCQButton = null;
                this._showDTButton = null;
                this._kwSubWidgetWrapper = null;
                this._componentCQContainer = null;
                this._componentDTSContainer = null;
                this._componentKWContainer = null;
                this._controlsContainer = null;
                this._clearButton = null;
                this._searchButton = null;
                this._useMinimalCQList = false;
                this._simpleKeyEditors = false;
                // Going to need several components
                this._cqModeActive = true; // True if we are doing a CQ, false if we are using doc types
                // Delegation behaviour
                this._usingDelegateKeywordPanel = false;
                // Internal data
                this._includeQueries = [];
                this._excludeQueries = [];
                this._includeDocTypes = [];
                this._excludeDocTypes = [];
                this._selectedDocTypes = [];
                this._preselectQuery = null;
                this._defaultDateOptionQuery = null;
                this._defaultDateOptionDocType = null;
                this._kwComponentReady = false;
                this._kwComponentClearDisplayRequested = false;
                this._kwComponentClearValuesRequested = false;
                this._kwComponentSearchRequested = false;
                this._kwComponentRequest = null;
                this.presentInstance = () => {
                    this._log.info("MultiSearchWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = MultiSearchWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._queryTypePanel = this._container.querySelector('#multiSearchSelectorPanel');
                    this._showCQButton = this._container.querySelector('#multiSearchShowQueriesButton');
                    this._showDTButton = this._container.querySelector('#multiSearchShowDocTypesButton');
                    this._componentCQContainer = this._container.querySelector('#multiSearchQueriesContainer');
                    this._componentDTSContainer = this._container.querySelector('#multiSearchDocTypesContainer');
                    this._kwSubWidgetWrapper = this._container.querySelector('#multiSearchKeywordsPlaceHolder');
                    ;
                    this._componentKWContainer = this._container.querySelector('#multiSearchKeywordsComponent');
                    this._controlsContainer = this._container.querySelector('#multiSearchControls');
                    this._clearButton = this._container.querySelector('#multiSearchClearBtn');
                    this._searchButton = this._container.querySelector('#multiSearchApplyBtn');
                    this._widgets.setTitle(this._config, this._container.querySelector('#multiSearchWidgetTitle'), 'STR_WPT_SEARCH');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#multiSearchKeywordsTitle'), 'STR_WPT_KEYWORDS');
                    this._core.Helper.setElementTranslation(this._clearButton.querySelector('#multiSearchClearBtnLabel'), 'STR_WPT_CLEAR');
                    this._core.Helper.setElementTranslation(this._searchButton.querySelector('#multiSearchApplyBtnLabel'), 'STR_WPT_SEARCH');
                    this._core.Helper.setElementTranslationAttribute(this._showCQButton, 'title', 'STR_WPT_SEARCH_BY_QUERY');
                    this._core.Helper.setElementTranslationAttribute(this._showDTButton, 'title', 'STR_WPT_SEARCH_BY_DOCTYPE');
                    this._clearButton.addEventListener('click', this._clearRequested);
                    this._searchButton.addEventListener('click', this._searchRequested);
                    // Sort out the query type tabs
                    if (!this._showQueries || !this._showDocTypes)
                        this._core.Functions.hideElement(this._queryTypePanel);
                    else {
                        this._showCQButton.addEventListener('click', this._customQuerySearchUIRequested);
                        this._showDTButton.addEventListener('click', this._docTypeSearchUIRequested);
                    }
                    if (this._showQueries) {
                        let cqConfig = {
                            CompressSelector: this._useMinimalCQList,
                            PreselectQuery: this._preselectQuery,
                            IncludeQueries: this._includeQueries,
                            ExcludeQueries: this._excludeQueries
                        };
                        this._componentCQ = new Widgets.ComponentCQChooser(this._core, this._componentCQContainer, this, cqConfig, this._querySelected);
                        this._cqModeActive = true;
                        this._showCQButton.classList.add('widget__menu-item--active');
                        this._showDTButton.classList.remove('widget__menu-item--active');
                        this._core.Functions.showElement(this._componentCQContainer);
                        this._core.Functions.hideElement(this._componentDTSContainer);
                        this._componentCQ.present();
                    }
                    if (this._showDocTypes) {
                        this._componentDTS = new Widgets.ComponentDocTypeSelector(this._core, this._componentDTSContainer, this, false, this._docTypeMultiSelect, this._includeDocTypes, this._excludeDocTypes);
                        this._componentDTS.SelectionCallback = this._docTypeSelected;
                        if (!this._showQueries) {
                            this._cqModeActive = false;
                            this._showCQButton.classList.remove('widget__menu-item--active');
                            this._showDTButton.classList.add('widget__menu-item--active');
                            this._core.Functions.hideElement(this._componentCQContainer);
                            this._core.Functions.showElement(this._componentDTSContainer);
                        }
                        this._componentDTS.present();
                    }
                    if (this._usingDelegateKeywordPanel) {
                        this._core.Functions.hideElement(this._kwSubWidgetWrapper);
                        this._core.Functions.hideElement(this._controlsContainer);
                    }
                    else {
                        this._componentKW = new Widgets.ComponentKeywordsSearch(this._core, this._componentKWContainer, this);
                        this._componentKW.present();
                        this._kwComponentReady = true;
                        if (this._kwComponentClearDisplayRequested) {
                            this._kwComponentClearDisplayRequested = false;
                            this._componentKW.clearDisplay();
                        }
                        else if (this._kwComponentClearValuesRequested) {
                            this._kwComponentClearValuesRequested = false;
                            this._componentKW.clearValues();
                        }
                        else {
                            if (this._kwComponentRequest != null) {
                                this._componentKW.makeRequest(this._kwComponentRequest);
                                this._kwComponentRequest = null;
                            }
                            if (this._kwComponentSearchRequested) {
                                this._kwComponentSearchRequested = false;
                                this._runSearch();
                            }
                        }
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this.addError(message);
                };
                this._customQuerySearchUIRequested = (event) => {
                    this._log.info("MultiSearchWidgetInstanceClass._customQuerySearchUIRequested()");
                    if (this._cqModeActive)
                        return;
                    this._cqModeActive = true;
                    this._showCQButton.classList.add('widget__menu-item--active');
                    this._showDTButton.classList.remove('widget__menu-item--active');
                    this._core.Functions.showElement(this._componentCQContainer);
                    this._core.Functions.hideElement(this._componentDTSContainer);
                    let previousQuery = this._componentCQ.SelectedQuery;
                    if (previousQuery)
                        this._querySelected(previousQuery);
                    else {
                        if (this._usingDelegateKeywordPanel) {
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCTYPE_DESELECTED);
                            navEvent.ActivationID = 0;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                        else {
                            if (this._kwComponentReady) {
                                this._componentKW.clearDisplay();
                            }
                            else {
                                this._kwComponentClearDisplayRequested = true;
                            }
                        }
                    }
                };
                this._docTypeSearchUIRequested = (event) => {
                    this._log.info("MultiSearchWidgetInstanceClass._docTypeSearchUIRequested()");
                    if (!this._cqModeActive)
                        return;
                    this._cqModeActive = false;
                    this._showCQButton.classList.remove('widget__menu-item--active');
                    this._showDTButton.classList.add('widget__menu-item--active');
                    this._core.Functions.hideElement(this._componentCQContainer);
                    this._core.Functions.showElement(this._componentDTSContainer);
                    let previousItems = this._componentDTS.SelectedDocTypes;
                    if (previousItems.length > 0)
                        this._docTypeSelected(previousItems);
                    else {
                        if (this._usingDelegateKeywordPanel) {
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_DESELECTED);
                            navEvent.ActivationID = 0;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                        else {
                            if (this._kwComponentReady) {
                                this._componentKW.clearDisplay();
                            }
                            else {
                                this._kwComponentClearDisplayRequested = true;
                            }
                        }
                    }
                };
                this._querySelected = (query) => {
                    if (this._usingDelegateKeywordPanel) {
                        let config = this._config;
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_SELECTED);
                        navEvent.ActivationID = query.Id;
                        navEvent.PrimaryContext = query;
                        navEvent.AdditionalContext['SimpleKeywordEditors'] = this._simpleKeyEditors;
                        if (this._defaultDateOptionQuery)
                            navEvent.AdditionalContext['DefaultDateOption'] = this._defaultDateOptionQuery;
                        let targetLayoutName = this._currentLayout;
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout != "[[CURRENT]]")
                                targetLayoutName = config.LaunchLayout;
                        }
                        navEvent.Layout = targetLayoutName;
                        // Add transfer widgets if we are moving
                        if ((targetLayoutName != this._currentLayout) && config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                    else {
                        let kwRequest = {
                            QueryName: query.Name,
                            DateOption: (this._defaultDateOptionQuery) ? this._defaultDateOptionQuery : null,
                            SimpleEditors: this._simpleKeyEditors
                        };
                        if (this._kwComponentReady) {
                            this._componentKW.makeRequest(kwRequest);
                        }
                        else {
                            this._kwComponentRequest = kwRequest;
                        }
                    }
                };
                this._docTypeSelected = (ids) => {
                    if (this._usingDelegateKeywordPanel) {
                        let config = this._config;
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCTYPES_SELECTED_SEARCH);
                        navEvent.ActivationID = ids.length;
                        navEvent.PrimaryContext = [];
                        ids.forEach(id => {
                            let numericId = Number(id);
                            if (numericId in this._core.OBHelper.DocumentTypesById)
                                navEvent.PrimaryContext.push(this._core.OBHelper.DocumentTypesById[numericId]);
                        });
                        navEvent.AdditionalContext['SimpleKeywordEditors'] = this._simpleKeyEditors;
                        if (this._defaultDateOptionDocType)
                            navEvent.AdditionalContext['DefaultDateOption'] = this._defaultDateOptionDocType;
                        let targetLayoutName = this._currentLayout;
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout != "[[CURRENT]]")
                                targetLayoutName = config.LaunchLayout;
                        }
                        navEvent.Layout = targetLayoutName;
                        // Add transfer widgets if we are moving
                        if ((targetLayoutName != this._currentLayout) && config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                    else {
                        if (ids.length == 0) {
                            if (this._kwComponentReady) {
                                this._componentKW.clearDisplay();
                            }
                            else {
                                this._kwComponentClearDisplayRequested = true;
                            }
                            return;
                        }
                        this._selectedDocTypes = [];
                        ids.forEach(id => {
                            let numericId = Number(id);
                            if (numericId in this._core.OBHelper.DocumentTypesById)
                                this._selectedDocTypes.push(this._core.OBHelper.DocumentTypesById[numericId].Name);
                        });
                        let kwRequest = {
                            DocTypes: this._selectedDocTypes,
                            DateOption: this._defaultDateOptionDocType,
                            SimpleEditors: this._simpleKeyEditors
                        };
                        if (this._kwComponentReady) {
                            this._componentKW.makeRequest(kwRequest);
                        }
                        else {
                            this._kwComponentRequest = kwRequest;
                        }
                    }
                };
                this._clearRequested = (event) => {
                    if (this._kwComponentReady) {
                        this._componentKW.clearValues();
                    }
                    else {
                        this._kwComponentClearValuesRequested = true;
                    }
                };
                this._searchRequested = (event) => {
                    this._log.info("MultiSearchWidgetInstanceClass._searchRequested()");
                    if (this._kwComponentReady) {
                        this._runSearch();
                    }
                    else {
                        this._kwComponentSearchRequested = true;
                    }
                };
                this._runSearch = () => {
                    this._log.info("MultiSearchWidgetInstanceClass._runSearch()");
                    if (this._componentKW.Valid) {
                        if (this._publishAsQuery)
                            this._publishQueryDefinition(this._componentKW.FlexSearchDef);
                        if (this._publishAsHitList)
                            this._executeSearch(this._componentKW.FlexSearchDef);
                    }
                    else
                        this._core.Helper.presentWarningModal('STR_WPT_REQUIRED_SEARCH_KEYS_MISSING');
                };
                this._publishQueryDefinition = (criteria) => {
                    this._log.info("MultiSearchWidgetInstanceClass._publishQueryDefinition()");
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_DEFINITION);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = criteria;
                    let targetLayoutName = "DocumentList";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._executeSearch = (criteria) => {
                    this._log.info("MultiSearchWidgetInstanceClass._executeSearch()");
                    let requestSearch = {
                        SearchDefinition: criteria,
                        ReturnQueues: false
                    };
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._publishHitList.bind(this, criteria), {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._publishHitList = (searchDef, response) => {
                    this._log.info("MultiSearchWidgetInstanceClass._publishHitList()");
                    if (response.hasOwnProperty('Documents') && response.Documents != null) {
                        this._log.trace("MultiSearchWidgetInstanceClass._publishHitList() has documents returned");
                        let config = this._config;
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_RESULT_DOCUMENTS);
                        navEvent.ActivationID = 0;
                        navEvent.PrimaryContext = response.Documents;
                        navEvent.AdditionalContext['FlexSearch'] = searchDef;
                        let targetLayoutName = "DocumentList";
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = config.LaunchLayout;
                        }
                        // Add transfer widgets if we are moving
                        if (targetLayoutName != this._currentLayout) {
                            if (config.hasOwnProperty("ForwardOtherWidgets")) {
                                navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                            }
                        }
                        navEvent.Layout = targetLayoutName;
                        this._log.trace("MultiSearchWidgetInstanceClass._publishHitList() activating");
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("MultiSearchWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                // Pull configuration in
                let conf = config;
                if (conf.hasOwnProperty('ShowCustomQueries') && (conf.ShowCustomQueries != null))
                    this._showQueries = conf.ShowCustomQueries;
                if (conf.hasOwnProperty('ShowDocumentTypes') && (conf.ShowDocumentTypes != null))
                    this._showDocTypes = conf.ShowDocumentTypes;
                if (conf.hasOwnProperty('AllowDocTypeMultiSelect') && (conf.AllowDocTypeMultiSelect != null))
                    this._docTypeMultiSelect = conf.AllowDocTypeMultiSelect;
                if (conf.hasOwnProperty('PublishAsQuery') && (conf.PublishAsQuery != null))
                    this._publishAsQuery = conf.PublishAsQuery;
                if (conf.hasOwnProperty('PublishAsHitList') && (conf.PublishAsHitList != null))
                    this._publishAsHitList = conf.PublishAsHitList;
                if (conf.hasOwnProperty('UseMinimalCQList') && (conf.UseMinimalCQList != null))
                    this._useMinimalCQList = conf.UseMinimalCQList;
                if (config.hasOwnProperty('DelegateKeywordPanel') && (conf.DelegateKeywordPanel != null))
                    this._usingDelegateKeywordPanel = conf.DelegateKeywordPanel;
                if (config.hasOwnProperty('SimpleKeywordEditors') && (conf.SimpleKeywordEditors != null))
                    this._simpleKeyEditors = conf.SimpleKeywordEditors;
                if (config.hasOwnProperty('IncludeQueries') && (conf.IncludeQueries != null))
                    this._includeQueries = conf.IncludeQueries;
                if (config.hasOwnProperty('ExcludeQueries') && (conf.ExcludeQueries != null))
                    this._excludeQueries = conf.ExcludeQueries;
                if (config.hasOwnProperty('IncludeDocTypes') && (conf.IncludeDocTypes != null))
                    this._includeDocTypes = conf.IncludeDocTypes;
                if (config.hasOwnProperty('ExcludeDocTypes') && (conf.ExcludeDocTypes != null))
                    this._excludeDocTypes = conf.ExcludeDocTypes;
                if (config.hasOwnProperty('PreselectQuery') && (conf.PreselectQuery != null))
                    this._preselectQuery = conf.PreselectQuery;
                if (config.hasOwnProperty('QueryDefaultDateOption') && (conf.QueryDefaultDateOption != null))
                    this._defaultDateOptionQuery = conf.QueryDefaultDateOption;
                if (config.hasOwnProperty('DocTypeDefaultDateOption') && (conf.DocTypeDefaultDateOption != null))
                    this._defaultDateOptionDocType = conf.DocTypeDefaultDateOption;
            }
        }
        MultiSearchWidgetInstanceClass.HtmlData = null;
        Widgets.MultiSearchWidgetInstanceClass = MultiSearchWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
